if (!customElements.get('sticky-button')) {
  class StickyButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      ['scroll', 'load'].forEach((event) =>
        window.addEventListener(event, this.handleSticky.bind(this)),
      );
    }

    handleSticky() {
      this.classList.toggle(
        'is-sticky',
        this.getBoundingClientRect(this).top < 0,
      );
    }
  }
  customElements.define('sticky-button', StickyButton);
}
